import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(window).resize( function() {
	if( window.innerWidth >= 660 && window.innerWidth < 1400 ) {
		let fontSize = ( window.innerWidth * 79 ) / 1400;
		$('#hero h1').css('font-size', fontSize);
	} else {
		$('#hero h1').css('font-size', '');
	}
});

$(window).trigger('resize');

if( window.hasOwnProperty('MktoForms2') ) {
	window.MktoForms2.onFormRender(function() {
		$('.mktoFormRow').each( function() {
			let $cols = $(this).find('> .mktoFormCol');
			let styles = '';
			if( $cols.length > 1 ) {
				let w = 100 / $cols.length;
				let i = 0;
				$cols.each( function() {
					$(this).attr('col-width-id', i);
					styles += '[col-width-id="'+ i +'"] { width: '+ w +'% !important; }';
					i++;
				});
			}
			$('head').append('<style>'+ styles +'</style>');
		});
		
		$('.mktoLabel').each( function() {
			if( $(this).siblings('.mktoCheckboxList').length ) {
				$(this).siblings('.mktoGutter').css('display', 'inline-block');
				$(this).css('display', 'inline-block');
			}
		});
	});
}